var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:([_vm.userCheck ? _vm.background_app : _vm.background])},[(_vm.userCheck)?_c('Navbar',{}):_vm._e(),_c('v-main',{staticClass:"mt-16 pt-1 mr-3 ml-3"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }